// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2dw0F","title":"BackImages_title__8mauA","images":"BackImages_images__3UEPl"};